var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpportunities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15054",
    "data-name": "Path 15054",
    d: "M0-682.665H32v32H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6228",
    "data-name": "Group 6228",
    transform: "translate(-292 -1365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_234",
    "data-name": "Ellipse 234",
    transform: "translate(295 1368)",
    fill: "#89d2f5",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 30.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(308 1380.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5152",
    "data-name": "Group 5152",
    transform: "translate(0 0.002)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15047",
    "data-name": "Path 15047",
    d: "M-582.4-291.2a14.321,14.321,0,0,1-14.321,14.321A14.321,14.321,0,0,1-611.04-291.2a14.321,14.321,0,0,1,14.321-14.321A14.321,14.321,0,0,1-582.4-291.2Z",
    transform: "translate(611.509 308.409)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    strokeDasharray: "516 35 600 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15048",
    "data-name": "Path 15048",
    d: "M-211.154-422.307a10.4,10.4,0,0,0,10.385-10.385,10.4,10.4,0,0,0-10.385-10.385,10.4,10.4,0,0,0-10.385,10.385A10.4,10.4,0,0,0-211.154-422.307Z",
    transform: "translate(225.944 449.902)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    strokeDasharray: "227 35 600 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15049",
    "data-name": "Path 15049",
    d: "M-131.108-262.217a6.455,6.455,0,0,1-6.448-6.448,6.455,6.455,0,0,1,6.448-6.448,6.455,6.455,0,0,1,6.448,6.448A6.455,6.455,0,0,1-131.108-262.217Z",
    transform: "translate(145.898 285.875)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15050",
    "data-name": "Path 15050",
    d: "M-51.063-102.126a2.514,2.514,0,0,1-2.511-2.511,2.514,2.514,0,0,1,2.511-2.511,2.514,2.514,0,0,1,2.511,2.511A2.514,2.514,0,0,1-51.063-102.126Z",
    transform: "translate(65.853 121.848)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15051",
    "data-name": "Path 15051",
    d: "M0-318.213l15.65-15.65",
    transform: "translate(14.79 335.423)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15052",
    "data-name": "Path 15052",
    d: "M-67.845-1.328l-3.142,3.142a.665.665,0,0,0-.194.512l.182,2.9,3.7-3.7-.17-2.708A.222.222,0,0,0-67.845-1.328Z",
    transform: "translate(95.911 1.862)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15053",
    "data-name": "Path 15053",
    d: "M-133.238-11.145-136.379-8a.665.665,0,0,1-.512.194l-2.9-.182,3.7-3.7,2.708.17A.222.222,0,0,1-133.238-11.145Z",
    transform: "translate(164.704 15.079)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpportunities);
export default __webpack_public_path__ + "static/media/opportunities.46fcce7dffd4bbf1bce17e5ec6a0ba1a.svg";
export { ForwardRef as ReactComponent };